module.exports = __webpack_public_path__ + "img/tbt-23-3-1999.prt.2553f397.jpg";